/**
 * Translate the admin UI's API configuration into the base URL Loyalty needs.
 * Loyalty appends `/api/v1` itself, so an absolute VITE_API_URL must hand over
 * the part before that suffix. Relative API routing shares the admin origin.
 */
export function platformBaseUrlForLoyalty(configuredApiUrl: string, adminOrigin: string): string {
  const configured = configuredApiUrl.trim();
  if (/^https?:\/\//i.test(configured)) {
    return configured.replace(/\/api\/v1\/?$/i, '').replace(/\/+$/, '');
  }
  return adminOrigin.replace(/\/+$/, '');
}
